/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_Member_DInputs */

const en_mk_sec_pg_role_member_d = /** @type {(inputs: Mk_Sec_Pg_Role_Member_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the day-to-day work, creates personal agents, and decides approvals for agents acting on their own behalf.`)
};

const id_mk_sec_pg_role_member_d = /** @type {(inputs: Mk_Sec_Pg_Role_Member_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengerjakan pekerjaan sehari-hari, membuat agen pribadi, dan memutuskan approval untuk agen yang bekerja atas namanya sendiri.`)
};

/**
* | output |
* | --- |
* | "Does the day-to-day work, creates personal agents, and decides approvals for agents acting on their own behalf." |
*
* @param {Mk_Sec_Pg_Role_Member_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_member_d = /** @type {((inputs?: Mk_Sec_Pg_Role_Member_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_Member_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_member_d(inputs)
	return en_mk_sec_pg_role_member_d(inputs)
});